/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fb': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path fill="white" d="M10 0a10 10 0 1 0 10 10A10 10 0 0 0 10 0zm2.85 5.83h-1.17c-.91 0-1.08.44-1.08 1.07v1.41h2.17l-.29 2.2H10.6v5.64H8.32v-5.64H6.43v-2.2h1.89V6.69a2.65 2.65 0 0 1 2.83-2.91 16 16 0 0 1 1.7.09z" _fill="#fff"/><path pid="1" d="M8.32 6.69v1.62H6.43v2.2h1.89v5.64h2.28v-5.64h1.88l.29-2.2H10.6V6.9c0-.63.17-1.07 1.08-1.07h1.17v-2a16 16 0 0 0-1.7-.09 2.65 2.65 0 0 0-2.83 2.95z"/>'
  }
})
